"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { SystemPerCapitaPoint } from "./SystemPerCapitaChart.impl";

export const SystemPerCapitaChart = dynamicChart(
  () =>
    import("./SystemPerCapitaChart.impl").then((m) => m.SystemPerCapitaChart),
  320,
);
